import { Mapper } from 'src/base/mapper'
import { GetFilterWithCountTypeEntity } from 'src/data/entities/base.entity'
import { GetFilterWithCountTypeModel } from 'src/domain/models/base.model'

export class GetFilterWithCountMapper extends Mapper<GetFilterWithCountTypeEntity, GetFilterWithCountTypeModel> {
	mapFrom(param: GetFilterWithCountTypeEntity): GetFilterWithCountTypeModel {
		return {
			id: null,
			name: param.name,
			count: param.count,
			value: param.value,
		}
	}

	mapTo(param: GetFilterWithCountTypeModel): GetFilterWithCountTypeEntity {
		return {
			name: param.name,
			count: param.count,
			value: param.value,
		}
	}
}
